import { apiClient } from './api';

export interface UserSettings {
  theme_preference?: 'light' | 'dark' | 'system';
  email_notifications?: 'true' | 'false';
  [key: string]: any;
}

export const settingsService = {
  // Get all user settings
  getSettings: async (): Promise<UserSettings> => {
    const { data } = await apiClient.get<UserSettings>('/settings');
    console.log('Fetched settings:', data);
    return data;
  },

  // Save one or more settings
  saveSettings: async (settings: Partial<UserSettings>): Promise<any> => {
    console.log('Saving settings:', settings);
    const { data } = await apiClient.post<any>('/settings', settings);
    console.log('Settings saved response:', data);
    return data;
  },
};
